<script>
import api from '@/command/api'
import apiTool from '@/command/apiTool'
import DrawerForm from '../../../components/DrawerForm'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import moment from 'moment'
import { getAction } from '@/command/netTool'

export default {
  name: 'balance',
  data() {
    return {
      ...api.command.getState(),
      paramsValue: {
        balanceType: '0',
      },
      balanceCompanyList: [],
      regionCode: [],
    }
  },
  mounted() {
    api.command.getList.call(this, {
      url: '/farmYghClientProduct/page',
      current: 1,
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '名称',
          key: 'name',
          type: 'input',
        },
        {
          name: '',
          key: '',
          type: 'text',
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'name',
          title: '名称',
          align: 'left',
        },
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          width: '10%',
          typeData: ({ records }) => {
            return [
              {
                name: '推送商品',
                onClick: () => {
                  getAction('/farmYghClientProduct/pushYghClient', {
                    yghClientId: records.id,
                  }).then((res) => {
                    this.$message.success('推送成功！')
                  })
                },
              },
              {
                name: '商品管理',
                onClick: () => {
                  this.$router.push({
                    path: `/marketingCenter/associationCommodity`,
                    query: {
                      id: records.id,
                    },
                  })
                },
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return []
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
        filterRightButtonKey={['refresh', 'setting']}
      />
    )
  },
}
</script>
